import { MessageBarType } from '@fluentui/react';
import * as React from 'react';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { EmailChangeView } from './EmailChangeView';
import * as Services from '../../../Services/Services';
import { IProfileApi } from '../../../Services/API/Profile/IProfileApi';
import { IAppStore } from '../../../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { IUserProfile } from '../../../Models/Profile/IUserProfile';
import { createEmitAndSemanticDiagnosticsBuilderProgram } from 'typescript';
import { validateEmail } from '../../../Tools/Validation';

interface IEmailChangeProps {
    profile: IUserProfile;
}

export const EmailChange: React.FunctionComponent<IEmailChangeProps> = (props) => {

    const [newEmail, setNewEmail] = React.useState("");
    const [emailConfirmation, setEmailConfirmation] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [canSave, setCanSave] = React.useState(false);

    const changeEmail = async () => {
        setIsLoading(true);
        setStatusMessage(undefined);
        const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
        const profile = await profileApi.changeEmail(newEmail, emailConfirmation);
        if (profile.isSuccess) {
            setStatusMessage({ message: profile.message, type: MessageBarType.success });
        }
        else {
            setStatusMessage({ message: profile.message, type: MessageBarType.error });
        }
        setIsLoading(false);
    }

    React.useEffect(() => {
        
    }, [props.profile])

    React.useEffect(() => {
        var result = (validateEmail(newEmail) !== null && validateEmail(emailConfirmation) !== null);
        setCanSave(result);
    }, [newEmail, emailConfirmation])

    return (<EmailChangeView
        isLoading={isLoading}
        isEmailVerified={false}
        canSave={canSave}
        oldEmail={props.profile.email}
        email={newEmail}
        emailConfirmation={emailConfirmation}
        onEmailChanged={setNewEmail}
        onEmailConfirmationChanged={setEmailConfirmation}
        changeEmail={changeEmail}
        width={400}
        statusMessage={statusMessage}
    />)
}

const EmailChangeToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,

});

const EmailChangeDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({
     
});

export default connect(EmailChangeToProps, EmailChangeDispatchToProps)(EmailChange);

